import { useEffect } from 'react';
import { qalTrackPageViewEvent } from 'thunks/analytics';

import { useAppDetails, useAppDispatch } from '../../hooks';

export default function useTrackRoute(pathname: string) {
  const dispatch = useAppDispatch();
  const { isInitialized } = useAppDetails();

  useEffect(() => {
    if (isInitialized) {
      dispatch(qalTrackPageViewEvent(pathname));
    }
  }, [pathname, dispatch, isInitialized]);
}
